import { useProjectContext } from "@contexts/projects";

export const formatWbsPath = (item) => {
  const { activeProject } = useProjectContext();
  const { appropriation_level } = activeProject

  const level = "wbs_code_id_" + appropriation_level

  return item[level].replace(activeProject?.wbs_code_id, "")

}

export const findWbsPath = (level, wbs) => {
  const { activeProject } = useProjectContext();
  const { appropriations } = activeProject

  const path = level === "units" ? 'building_unit_name' : 'description'

  const res = appropriations[level]?.find(i => i.wbs_code_id === wbs)?.[path] ?? "-"

  return res
}